function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, String, headerHeight, searchQuery) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['header'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'chart-header': true,
            'chart-legend-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Legend");;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const readOnly = $attr(`read-only`);
    const sections = $attr(`sections`) || $helpers.getSections();
    return {
      value: (h("div", {
        "style": $helpers.overrideStyle(),
        "class": {
          'chart-legend': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((!readOnly) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "style": {
              'max-height': headerHeight
            },
            "class": {
              'header-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['header'].call(this));
            __jade_nodes = __jade_nodes.concat(($attr(`enable-search`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'chart-legend-search': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-icon-input", {
                  "attrs": {
                    icon: `search`,
                    placeholder: `Search`,
                  },
                  "hook": {
                    insert: ({
                      elm
                    }) => $component.setElRef(`searchInput`, elm),
                  },
                  "on": {
                    input: $helpers.updateLegendSearch
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'chart-legend-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
              "style": {
                height: $helpers.getItemsMenuHeight()
              },
              "attrs": {
                multiple: true,
                'search-filter': searchQuery,
                'sections': JSON.stringify(sections),
                'show-select-all': $attr(`show-select-all`),
                'progressive': !!$attr(`height`) && $attr(`progressive`),
              },
              "on": {
                clickItem: $helpers.toggledCheckbox,
                selectAll: $helpers.toggledAllCheckboxes,
              },
              "hook": {
                insert: ({
                  elm
                }) => elm.keydownProxyEl = $component.elRefs.searchInput,
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          const selectedSections = $helpers.filterSelected(sections);
          __jade_nodes = __jade_nodes.concat(jade_mixins['header'].call(this));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'readonly': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = (selectedSections);
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, section, idx) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((idx > 0) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'section-divider': true
                        },
                      }));;
                      return __jade_nodes
                    }).call(this)) : undefined);
                    __jade_nodes = __jade_nodes.concat((section.label) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'readonly-section-label': true
                        },
                      }, [__vjadeSafeCode(section.label)]));;
                      return __jade_nodes
                    }).call(this)) : undefined);
                    __jade_nodes = __jade_nodes.concat((function() {
                      var $$obj = (section.items);
                      var $$eachNodes;
                      var $$iterated = false;
                      if (Array.isArray($$obj)) {
                        $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                          $$iterated = true;
                          return $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'readonly-item': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'readonly-color-wrapper': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "style": {
                                    'background-color': item.color
                                  },
                                  "class": {
                                    'readonly-item-color': true
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'readonly-item-label': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(item.label)]));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this));
                        }, []);
                      } else {
                        $$eachNodes = [];
                        for (var $$objKey in $$obj) {
                          (function() {
                            var $index = $$objKey;
                            if ($$obj.hasOwnProperty($index)) {
                              $$iterated = true;
                              var item = $$obj[$index];
                              $$eachNodes = $$eachNodes.concat((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'readonly-item': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'readonly-color-wrapper': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "style": {
                                        'background-color': item.color
                                      },
                                      "class": {
                                        'readonly-item-color': true
                                      },
                                    }));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'readonly-item-label': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(item.label)]));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this));
                            }
                          })();
                        }
                      }

                      return $$eachNodes;
                    })());;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var idx = $$objKey;
                    if ($$obj.hasOwnProperty(idx)) {
                      $$iterated = true;
                      var section = $$obj[idx];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((idx > 0) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'section-divider': true
                            },
                          }));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat((section.label) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'readonly-section-label': true
                            },
                          }, [__vjadeSafeCode(section.label)]));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat((function() {
                          var $$obj = (section.items);
                          var $$eachNodes;
                          var $$iterated = false;
                          if (Array.isArray($$obj)) {
                            $$eachNodes = $$obj.reduce(function($$eachNodes, item, $index) {
                              $$iterated = true;
                              return $$eachNodes.concat((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'readonly-item': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'readonly-color-wrapper': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "style": {
                                        'background-color': item.color
                                      },
                                      "class": {
                                        'readonly-item-color': true
                                      },
                                    }));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'readonly-item-label': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(item.label)]));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this));
                            }, []);
                          } else {
                            $$eachNodes = [];
                            for (var $$objKey in $$obj) {
                              (function() {
                                var $index = $$objKey;
                                if ($$obj.hasOwnProperty($index)) {
                                  $$iterated = true;
                                  var item = $$obj[$index];
                                  $$eachNodes = $$eachNodes.concat((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'readonly-item': true
                                      },
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'readonly-color-wrapper': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "style": {
                                            'background-color': item.color
                                          },
                                          "class": {
                                            'readonly-item-color': true
                                          },
                                        }));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'readonly-item-label': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(item.label)]));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this));
                                }
                              })();
                            }
                          }

                          return $$eachNodes;
                        })());;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "headerHeight" in locals ? locals.headerHeight : typeof headerHeight !== "undefined" ? headerHeight : undefined, "searchQuery" in locals ? locals.searchQuery : typeof searchQuery !== "undefined" ? searchQuery : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;